/* __next_internal_client_entry_do_not_use__ MaybeMobileSearchBarXP auto */ import { jsx as _jsx } from "react/jsx-runtime";
import { Core } from "@faire/design-tokens";
import { HeaderSearch } from "@faire/retailer-visitor-shared/components/Header/HeaderSearch";
import { useIsLoggedInRetailer } from "@faire/retailer-visitor-shared/lib/isLoggedInRetailer";
import { useSettingNavSearchUX } from "@faire/retailer-visitor-shared/settings/useSettingNavSearchUX";
import { useTopOfPageContent } from "@faire/retailer-visitor-shared/stores/ui/useTopOfPageContent";
import { useDetectScroll } from "@faire/web--source/ui/hooks/useDetectScroll";
import { useViewport } from "@faire/web--source/ui/hooks/useViewport";
import * as React from "react";
import { useMemo } from "react";
import styled from "styled-components";
var SEARCH_HEIGHT = 64;
export var MaybeMobileSearchBarXP = function(param) {
    var isSeparateFromHeader = param.isSeparateFromHeader;
    var isTabletAndAbove = useViewport().isTabletAndAbove;
    var isLoggedInRetailer = useIsLoggedInRetailer();
    var scrollDirection = useDetectScroll("y", 5).scrollDirection;
    var _useSettingNavSearchUX = useSettingNavSearchUX(), isNavSearchUX = _useSettingNavSearchUX.isTreatment, isStickyVariant = _useSettingNavSearchUX.isStickyVariant;
    var headerHeight = useTopOfPageContent().headerHeight;
    var topPosition = useMemo(function() {
        return scrollDirection === "up" || isStickyVariant ? headerHeight - 1 : headerHeight - SEARCH_HEIGHT - 1;
    }, [
        scrollDirection,
        isStickyVariant,
        headerHeight
    ]);
    if (isTabletAndAbove || !isLoggedInRetailer && !isNavSearchUX || isLoggedInRetailer && isSeparateFromHeader) {
        return null;
    }
    if (isLoggedInRetailer) {
        return /*#__PURE__*/ _jsx(HeaderSearch, {
            inputId: "mobile-top-search-xp",
            inputDataTestId: "mobileSearchBarInput"
        });
    }
    return /*#__PURE__*/ _jsx(Wrapper, {
        $topPosition: topPosition,
        children: /*#__PURE__*/ _jsx(HeaderSearch, {
            inputId: "mobile-top-search-xp",
            inputDataTestId: "mobileSearchBarInput"
        })
    });
};
var Wrapper = styled.div.withConfig({
    componentId: "sc-c5554eec-0"
})([
    "width:100%;transition:top 0.3s ease-in-out;top:",
    "px;position:sticky;z-index:11;border-bottom:1px solid ",
    ";"
], function(props) {
    return props.$topPosition;
}, Core.border.muted);
